export default __webpack_public_path__ + "static/media/uber-screen.2fe614bc.png";